import groq from "groq";

export const RELEASE_NOTE_QUERY = groq`
*[_type == "releaseNote" && slug.current == $slug][0]{
  _id,
  title,
  slug,
  featureImage{
    ...
    asset->
  },
  releaseDate,
  content[]{
    ...,
    _type == "image" => {
      ...,
      asset->
    }
  }
}`;
